import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogoutOutlined, MenuOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import { differenceInCalendarDays } from 'date-fns';

import { SubscriptionType } from '@/core/enums/subscriptionType';
import { useAppDispatch, useAppSelector } from '@/core/redux/hooks';
import { appSettingsSelectors } from '@/core/redux/slices/app/selectors';
import { appSettingsActions } from '@/core/redux/slices/app/slice';
import { authActions } from '@/core/redux/slices/auth/slice';
import { usersSelectors } from '@/core/redux/slices/users/selectors';
import { declination } from '@/helpers/converter';
import Logo from '@/images/logo-light.svg';
import User from '@/images/user.svg';
const { Text } = Typography;

export const Header: React.FC = () => {
  const user = useAppSelector(usersSelectors.user);
  const { auto_renew, payment_status, plan_type, ends_at } =
    user?.subscription || { ends_at: '', plan_type: 'trial' };
  const count_days = differenceInCalendarDays(new Date(ends_at), new Date());

  const org_count_days = user?.organization_subscription_ends_at
    ? differenceInCalendarDays(
        new Date(user?.organization_subscription_ends_at),
        new Date()
      )
    : 0;

  const isSidebarShort = useAppSelector(appSettingsSelectors.isSidebarShort);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onLogOut = () => {
    dispatch(authActions.logout());
  };

  useEffect(() => {
    localStorage.setItem('is_sidebar_short', isSidebarShort.toString());
  }, [isSidebarShort]);

  const handleChangeSidebarSize = () => {
    dispatch(appSettingsActions.setSidebarShort(!isSidebarShort));
  };

  const getSubscriptionComponent = () => {
    if (user?.organization_id && org_count_days > 0) {
      return (
        <React.Fragment>
          <div className='ml-2 bg-[#E6F7FF] rounded-xl px-2 py-[2px] text-[12px] px-[8px] z-10'>
            Командная
          </div>
          <div className='px-[8px] py-[1px] border border-1 border-gray-400 rounded-full text-[12px] pl-[25px] ml-[-20px] text-white'>
            Осталось {declination('day', org_count_days)}
          </div>
        </React.Fragment>
      );
    }
    if (auto_renew && payment_status === 'succeeded' && count_days >= 0) {
      // Подписка активна, и карта привязана
      return (
        <div className='ml-2 px-[8px] py-[1px] border border-1 border-gray-400 rounded-full text-[12px] text-white'>
          {SubscriptionType?.[plan_type]}
        </div>
      );
    } else if (count_days < 0 || payment_status !== 'succeeded') {
      // Триал закончился, нет подписки”включить подписку” ведет на профиль в разделе “подписка”
      return (
        <React.Fragment>
          <div className='ml-2 pl-[8px] pr-[35px] py-[1px] border border-1 border-gray-400 rounded-full text-[12px] text-white'>
            Пробный
          </div>
          <div
            className='bg-[#E6F7FF] rounded-xl px-2 py-[2px] text-[12px] ml-[-30px] cursor-pointer'
            onClick={() => navigate('/profile/subscription')}
          >
            Включить подписку
          </div>
        </React.Fragment>
      );
    } else if (
      !auto_renew &&
      payment_status === 'succeeded' &&
      count_days > 0
    ) {
      // Отключено продление подписки
      return (
        <React.Fragment>
          <div className='ml-2 bg-[#E6F7FF] rounded-xl px-2 py-[2px] text-[12px] px-[8px] z-10'>
            {SubscriptionType?.[plan_type]}
          </div>
          <div className='px-[8px] py-[1px] border border-1 border-gray-400 rounded-full text-[12px] pl-[25px] ml-[-20px] text-white'>
            Осталось {declination('day', count_days)}
          </div>
        </React.Fragment>
      );
    } else if (
      !auto_renew &&
      payment_status === 'succeeded' &&
      count_days === 0
    ) {
      return (
        <React.Fragment>
          <div className='ml-2 bg-[#E6F7FF] rounded-xl px-2 py-[2px] text-[12px] px-[8px] z-10'>
            {SubscriptionType?.[plan_type]}
          </div>
          <div className='px-[8px] py-[1px] border border-1 border-gray-400 rounded-full text-[12px] pl-[25px] ml-[-20px] text-white'>
            Сегодня заканчивается подписка
          </div>
        </React.Fragment>
      );
    }
    return null;
  };

  return (
    <div className='bg-primary-dark h-12 flex justify-between items-center px-4'>
      <div className='flex items-center'>
        <Button
          type='link'
          onClick={handleChangeSidebarSize}
          className='text-white pl-[14px] pr-[14px] mr-[25px]'
        >
          <MenuOutlined style={{ fontSize: '21px' }} />
        </Button>
        <img src={Logo} alt='Аэропро.Эксперт' />
        {getSubscriptionComponent()}
      </div>
      {user && (
        <div className=' flex gap-2 items-center'>
          <Link
            to={{
              pathname: '/profile/user',
            }}
          >
            <img src={User} alt='Аэропро.Эксперт' />
          </Link>

          <Text className='text-white'>{user.name}</Text>
          <Button type='link' onClick={onLogOut}>
            <LogoutOutlined style={{ fontSize: '20px', color: 'white' }} />
          </Button>
        </div>
      )}
    </div>
  );
};
